<template>
  <v-snackbar :timeout="3000" :color="color" v-model="snackbarShow">
    {{ message }}
    <v-btn dark flat @click.native="snackbarShow = false">Zamknij</v-btn>
  </v-snackbar>
</template>

<script>
export default {
  props: ['color', 'message', 'snackbar'],
  computed: {
    snackbarShow: {
      get: function () {
        return this.snackbar
      },
      set: function (val) {
        this.$emit('update:snackbar', val)
      }
    }
  }
}
</script>